import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { NotificationPreferencesForm } from "./NotificationPreferencesForm";

interface NotificationPreferencesModalProps {
  open: boolean;
  onClose: () => void;
}

/** Casca fina: o conteúdo real mora em NotificationPreferencesForm (também usado em Settings). */
export function NotificationPreferencesModal({ open, onClose }: NotificationPreferencesModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>Preferências de Notificação</DialogTitle>
          <DialogDescription>
            Escolha como quer ser avisado em cada tipo de evento. Padrão: app e push ligados.
          </DialogDescription>
        </DialogHeader>
        <NotificationPreferencesForm onSaved={onClose} onCancel={onClose} />
      </DialogContent>
    </Dialog>
  );
}
